import isEqual from 'lodash/isEqual';

const isDeepEqual = (a: unknown, b: unknown) => {
  let aa = a;
  let bb = b;

  if (typeof a === 'object') {
    aa = JSON.parse(JSON.stringify(a));
  }

  if (typeof b === 'object') {
    bb = JSON.parse(JSON.stringify(b));
  }

  return isEqual(aa, bb);
};

export default isDeepEqual;
